import { Component } from "@angular/core";
import { ReactPageComponent } from "../../../../common";
import { OrdersPage } from "./page";

@Component({
  selector: "app-page-orders",
  template: '<div class="react-page" #container></div>'
})
export class PageOrdersComponent extends ReactPageComponent {
  get Component() {
    return OrdersPage;
  }
}
